module.exports = __webpack_public_path__ + "img/88.bb53b73c.svg";